import type { Policy } from '@/permissions/types';

// Learning paths use RED1000's automated proofreading service.
// SaaS coordinators can use them when their school has RED1000 proofreading credits —
// that check is done by the learning path availability endpoint (task-creation feature).
export const learningPathPolicies: Policy[] = [
  {
    name: 'view:learning_path',
    evaluate: ({ user }) =>
      ['COORDENADOR_ESCOLA', 'COORDENADOR_TURMA', 'COORDENADOR_SAAS', 'ADMIN', 'SUPER_ADMIN'].includes(user.perfil),
  },
  {
    name: 'create:learning_path',
    evaluate: ({ user }) =>
      ['COORDENADOR_ESCOLA', 'COORDENADOR_TURMA', 'COORDENADOR_SAAS', 'ADMIN', 'SUPER_ADMIN'].includes(user.perfil),
  },
];
